import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IState, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVCheckbox } from "../../shared/JVCheckbox";

const schema = yup.object({
    name: yup.string().required("State Name is required"),
    countryId: yup.number().required("Country is required").min(1, "Country is required")
});

interface Iprops {
    singleData: IState,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [countries, setCountries] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IState>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        loadCountries();
    }, []);

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadCountries = async () => {
        const response = await Fetch("country/dropdown", "GET", null, null, null);
        if (response) {
            setCountries(await response.json());
        }
    }

    const saveToDB = async (body: IState) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`state${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit State" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={1} required label="Country" control={control} options={countries} optionLabel="name" optionValue="id" name="countryId" placeholder="Select Country" error={errors.countryId?.message} />
                <JVInput column={1} required label="State Name" control={control} name="name" error={errors.name?.message} />
                <JVCheckbox column={1} label="IsTouristDestination" control={control} name="isTouristDestination" />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}